import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.36 6.33c.4 0 .65.46.4.8l-2.35 3.3a.5.5 0 01-.82 0l-2.36-3.3a.5.5 0 01.4-.8h4.73z" fill="currentColor" /></svg>);